import { fulfilled, pending, rejected } from '../../../utils';
import { ZIP_CERTIFICATE } from '../../actions/actiontype';

const initialState = {
	status: '',
	loading: false,
	message: '',
	data: '',
	error: '',
};

const zipCertificateReducer = (state = initialState, action) => {
	switch (action.type) {
		case pending(ZIP_CERTIFICATE):
			return {
				...state,
				loading: true,
				message: '',
				data: '',
				status: '',
				error: '',
			};
		case fulfilled(ZIP_CERTIFICATE):
			return {
				...state,
				loading: false,
				status: action.payload.data.status,
				message: action.payload.data.message,
				data: action.payload.data.data,
				error: '',
			};
		case rejected(ZIP_CERTIFICATE):
			return {
				...state,
				loading: false,
				message: '',
				error: status ===500 ? "Something went wrong. Please try again later" : action?.payload?.response.data.message,
			};
		default:
			return state;
	}
};

export default zipCertificateReducer;
